import { render, staticRenderFns } from "./00_input_size.vue?vue&type=template&id=04551f71&scoped=true&"
import script from "./00_input_size.vue?vue&type=script&lang=js&"
export * from "./00_input_size.vue?vue&type=script&lang=js&"
import style0 from "./00_input_size.vue?vue&type=style&index=0&id=04551f71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04551f71",
  null
  
)

export default component.exports